<div class="mat-display-3 mt-4 mb-2 ta-c">Projects</div>

<div class="previews">
    <app-project-preview *ngFor="let project of projects" [project]="project"></app-project-preview>
</div>